<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M13.333 11.834a1.5 1.5 0 00-1.5 1.5V24a1.5 1.5 0 103 0v-7.045L30.5 32.62v18.046a1.5 1.5 0 103 0V32a1.5 1.5 0 00-.44-1.06L16.956 14.832H24a1.5 1.5 0 000-3H13.333zm35.834 5.12V24a1.5 1.5 0 003 0V13.334a1.5 1.5 0 00-1.5-1.5H40a1.5 1.5 0 000 3h7.045l-9.44 9.439a1.5 1.5 0 002.122 2.121l9.44-9.44z"/></svg>